/**
 * 一文字ずつ電球が温まるように灯る見出し。読み上げは親の aria-label に任せる。
 * delay は前の行の文字数（行をまたいで灯りが続くようにする）
 */
const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' })

/**
 * 見た目の一文字（書記素）ごとに分ける。コードポイントで分けると、デーヴァナーガリーの母音記号や
 * タイ文字の声調記号が親の文字から離れて、点線の丸つきで描かれてしまう
 */
export function graphemes(text: string): string[] {
  return Array.from(segmenter.segment(text), (s) => s.segment)
}

export function Ignite({
  text,
  className = '',
  delay = 0,
}: {
  text: string
  className?: string
  delay?: number
}) {
  return (
    <span className={`ignite ${className}`} aria-hidden="true">
      {graphemes(text).map((ch, i) => (
        <span
          // 文字の並びは変わらないので位置で区別する
          // biome-ignore lint/suspicious/noArrayIndexKey: 静的な文字列
          key={i}
          className="ignite__ch"
          style={{ ['--i' as string]: i + delay }}
        >
          {ch === ' ' ? ' ' : ch}
        </span>
      ))}
    </span>
  )
}
